import { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { RxCross1 } from 'react-icons/rx';
import Button from '@/components/elements/Button';
import type { ReactNode } from 'react';

interface DrawerProps {
  children: ReactNode;
  buttonContent?: ReactNode | string;
}

function Drawer({ children, buttonContent }: DrawerProps) {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  function openDrawer() {
    setIsOpen(true);
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    setIsOpen(false);
    document.body.style.overflow = 'auto';
  }

  return (
    <>
      <Button variant='icon' onClick={openDrawer} aria-label='Toggle drawer open state'>
        {buttonContent}
      </Button>

      <AnimatePresence>
        {isOpen && (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 0.5 }}
              exit={{ opacity: 0 }}
              onClick={closeDrawer}
              className='fixed inset-0 bg-black z-40'
            />

            <motion.div
              initial={{ y: '100%' }}
              animate={{ y: 0 }}
              exit={{ y: '100%' }}
              transition={{ type: 'ease-in-out' }}
              className='fixed bottom-0 left-0 right-0 bg-white rounded-t-md z-50 shadow-lg max-h-[85vh] overflow-y-auto'
            >
              <button onClick={closeDrawer} className='right-1.5 top-1 text-white absolute ml-auto p-2 rounded-full'>
                <RxCross1 className='w-5 h-5' />
              </button>

              <div>{children}</div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </>
  );
}

export default Drawer;
